import React, { useState } from 'react';
import { Delete, CornerDownLeft, X } from 'lucide-react';

export default function VirtualKeyboard({ onKeyPress, onBackspace, onClear, onClose }) {
  const [shift, setShift] = useState(false);

  const row1 = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];
  const row2 = ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P'];
  const row3 = ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L'];
  const row4 = ['Z', 'X', 'C', 'V', 'B', 'N', 'M', '@', '.', '-'];

  const handleKey = (char) => {
    onKeyPress(shift ? char : char.toLowerCase());
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-slate-900/95 backdrop-blur-xl border-t border-cyan-500/30 p-3 shadow-2xl animate-in slide-in-from-bottom duration-200">
      <div className="max-w-4xl mx-auto flex flex-col space-y-2">
        {/* Top bar with close */}
        <div className="flex items-center justify-between px-2 pb-1 border-b border-white/10">
          <span className="text-xs font-semibold uppercase tracking-wider text-cyan-400">Touch Screen Keyboard</span>
          <button
            onClick={onClose}
            className="p-1 rounded-md text-slate-400 hover:text-white hover:bg-slate-800"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Row 1: Numbers */}
        <div className="flex justify-center gap-1.5">
          {row1.map((num) => (
            <button
              key={num}
              onClick={() => handleKey(num)}
              className="flex-1 max-w-[70px] h-12 rounded-lg bg-slate-800 hover:bg-cyan-950/60 active:bg-cyan-600 text-white font-bold text-lg border border-white/5 active:scale-95 transition-all shadow"
            >
              {num}
            </button>
          ))}
        </div>

        {/* Row 2 */}
        <div className="flex justify-center gap-1.5">
          {row2.map((char) => (
            <button
              key={char}
              onClick={() => handleKey(char)}
              className="flex-1 max-w-[70px] h-12 rounded-lg bg-slate-800 hover:bg-cyan-950/60 active:bg-cyan-600 text-white font-semibold text-lg border border-white/5 active:scale-95 transition-all shadow"
            >
              {shift ? char : char.toLowerCase()}
            </button>
          ))}
        </div>

        {/* Row 3 */}
        <div className="flex justify-center gap-1.5 px-4">
          {row3.map((char) => (
            <button
              key={char}
              onClick={() => handleKey(char)}
              className="flex-1 max-w-[70px] h-12 rounded-lg bg-slate-800 hover:bg-cyan-950/60 active:bg-cyan-600 text-white font-semibold text-lg border border-white/5 active:scale-95 transition-all shadow"
            >
              {shift ? char : char.toLowerCase()}
            </button>
          ))}
        </div>

        {/* Row 4 */}
        <div className="flex justify-center gap-1.5">
          <button
            onClick={() => setShift(!shift)}
            className={`px-4 h-12 rounded-lg font-bold text-xs uppercase border border-white/5 transition-all shadow ${shift ? 'bg-cyan-500 text-slate-950' : 'bg-slate-800 text-slate-300'}`}
          >
            Shift
          </button>
          {row4.map((char) => (
            <button
              key={char}
              onClick={() => handleKey(char)}
              className="flex-1 max-w-[64px] h-12 rounded-lg bg-slate-800 hover:bg-cyan-950/60 active:bg-cyan-600 text-white font-semibold text-lg border border-white/5 active:scale-95 transition-all shadow"
            >
              {shift ? char : char.toLowerCase()}
            </button>
          ))}
          <button
            onClick={onBackspace}
            className="px-4 h-12 rounded-lg bg-red-950/50 hover:bg-red-900 active:bg-red-600 text-red-200 border border-red-800/40 flex items-center justify-center transition-all shadow active:scale-95"
          >
            <Delete className="w-5 h-5" />
          </button>
        </div>

        {/* Bottom Row: Space & Clear */}
        <div className="flex justify-center gap-2 pt-1">
          <button
            onClick={onClear}
            className="px-6 h-12 rounded-lg bg-slate-800 hover:bg-slate-700 text-slate-300 text-sm font-semibold border border-white/5 active:scale-95 transition-all shadow"
          >
            Clear All
          </button>
          <button
            onClick={() => onKeyPress(' ')}
            className="flex-1 max-w-xl h-12 rounded-lg bg-slate-800 hover:bg-slate-700 active:bg-cyan-600 text-slate-300 font-semibold text-sm border border-white/5 active:scale-95 transition-all shadow tracking-wider uppercase"
          >
            Space
          </button>
          <button
            onClick={onClose}
            className="px-6 h-12 rounded-lg bg-cyan-600 hover:bg-cyan-500 active:bg-cyan-400 text-slate-950 font-bold text-sm border border-cyan-400/30 flex items-center gap-1.5 active:scale-95 transition-all shadow"
          >
            <CornerDownLeft className="w-4 h-4" /> Done
          </button>
        </div>
      </div>
    </div>
  );
}
